<template
  xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
  xmlns:v-slot="http://www.w3.org/1999/XSL/Transform"
>
  <div id="projectOverview-container" class="main-layout bg-background">
    <div class="main-wrapper mt-1 pt-1">
      <h1 ref="project-name" class="pb-5 mb-5 itemis-analyze-headline">
        {{ currentSelectedProject?.name }}
      </h1>

      <v-expansion-panels v-model="expansionPanels" multiple>
        <v-expansion-panel elevation="0" class="pl-4 pr-4 rounded-lg">
          <v-expansion-panel-title>
            <template #default="{}">
              <v-row no-gutters>
                <v-col cols="4" class="d-flex justify-start">
                  <h2 class="itemis-analyze-title">
                    {{ labels.HOMEPAGE.DETAILS.SNAPSHOT_BROWSER }}
                  </h2>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div>
              <snapshot-list />
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel elevation="0" class="pr-4 pl-4 rounded-lg">
          <v-expansion-panel-title>
            <template #default="{}">
              <v-row no-gutters>
                <v-col cols="4" class="d-flex justify-start">
                  <h2 class="itemis-analyze-title">
                    {{ labels.GLOBAL_FILTER.GLOBAL_FILTERS }}
                  </h2>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div>
              <global-filters-list />
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel
          v-if="projectStore.isFeatureActive('analyze:custom-metrics')"
          elevation="0"
          class="pr-4 pl-4 rounded-lg"
        >
          <v-expansion-panel-title>
            <template #default="{}">
              <v-row no-gutters>
                <v-col cols="4" class="d-flex justify-start">
                  <h2 class="itemis-analyze-title">
                    {{ labels.CUSTOM_METRIC.CUSTOM_METRICS }}
                  </h2>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div>
              <custom-metrics-list />
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { EventBus } from '@/event-bus'
  import { Project } from '@/models'
  import { onMounted, ref } from 'vue'
  import { useProjectStore } from '@/stores/projectStore'
  import { computed } from 'vue'
  import SnapshotList from '@/pages/project/SnapshotList.vue'
  import GlobalFiltersList from './GlobalFiltersList.vue'
  import CustomMetricsList from './CustomMetricsList.vue'
  import labels from '@/translations/labels.json'

  const projectStore = useProjectStore()
  const isProjectSelected = ref(false)
  const isSelecting = ref(false)
  const selectedFile = ref<File | undefined>(undefined)

  const expansionPanels = ref([0, 1, 2])

  const currentSelectedProject = computed((): Project | undefined => {
    const currentProject = projectStore.currentProject
    return currentProject
  })

  onMounted(() => {
    selectedFile.value = undefined

    getCurrentProject()
    EventBus.on('uploaded', () => {
      isSelecting.value = false
    })
  })

  function getCurrentProject(): void {
    if (
      currentSelectedProject.value !== undefined &&
      currentSelectedProject.value.id !== undefined
    ) {
      isProjectSelected.value = true
    }
  }
</script>

<style lang="scss" scoped>
  #fileUpload {
    display: none;
  }
  .inline-header-container {
    display: inline-flex;
    align-items: center;
  }

  .edit-icon {
    margin-left: 10px; /* Add space between the text and the icon */
  }
</style>
<style lang="scss">
  .v-expansion-panel-title__overlay {
    background-color: white;
  }

  .v-expansion-panel {
    outline-width: 1px;
    outline-style: solid;
    outline-color: rgb(var(--v-theme-grey-medium));
  }

  div.v-expansion-panel-text__wrapper {
    padding-top: 0px !important;
  }
</style>
